import styled from "styled-components";
import { MdOutlineWaterDrop, MdThermostat, MdWaterDrop } from "react-icons/md";
import { gray300, gray700, gray900, green, white, blue, red100 } from "core/resources/theme/colors";
import { WxSummaryData } from "./types";

type Props = {
  data: WxSummaryData;
};

function formatValue(value: number | null, digits = 1) {
  if (value === null || value === undefined) return "-";
  return Number(value).toLocaleString("pt-BR", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

function WxSummary({ data }: Props) {
  return (
    <Aside>
      <Metric>
        <IconWrap>
          <MdWaterDrop size={18} color={blue} />
        </IconWrap>
        <div>
          <Label>Total chuva</Label>
          <Value>
            {formatValue(data.totalRainMm)} <Unit>mm</Unit>
          </Value>
        </div>
      </Metric>
      <Metric>
        <IconWrap>
          <MdThermostat size={18} color={red100} />
        </IconWrap>
        <div>
          <Label>Temp. média</Label>
          <Value>
            {formatValue(data.avgTempC)} <Unit>ºC</Unit>
          </Value>
        </div>
      </Metric>
      <Metric>
        <IconWrap>
          <MdOutlineWaterDrop size={18} color={blue} />
        </IconWrap>
        <div>
          <Label>Umidade média</Label>
          <Value>
            {formatValue(data.avgHumidityPct, 0)} <Unit>%</Unit>
          </Value>
        </div>
      </Metric>
    </Aside>
  );
}

export default WxSummary;

const Aside = styled.aside`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  padding: 6px 8px 6px 12px;
  border-left: 1px solid ${gray300};
  min-width: 128px;
`;

const Metric = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const IconWrap = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: ${white};
  border: 1px solid ${gray300};
  display: grid;
  place-items: center;
  flex-shrink: 0;
`;

const Label = styled.span`
  display: block;
  font-size: 0.66rem;
  color: ${gray700};
  font-weight: 600;
`;

const Value = styled.strong`
  font-size: 0.95rem;
  font-weight: 800;
  color: ${gray900};
`;

const Unit = styled.small`
  font-size: 0.68rem;
  font-weight: 600;
  color: ${gray700};
`;
